import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import SVG from 'react-inlinesvg';
import Chevron from '../../../assets/svg/iconLib/chevron-down.svg';

import { StyledSelect, SelectWrapper } from './styles';

const Select = forwardRef(
  ({ options, required, defaultValue, placeholder, error, ...rest }, ref) => {
    if (!options || options.length < 1) return null;

    return (
      <SelectWrapper>
        <StyledSelect
          $error={error}
          {...rest}
          label={null}
          ref={ref}
          data-input-scroll-id={rest.name}
        >
          {/**
           * N.B. This placeholder is usually rendered and blank as it's a "true"
           * value passed by our Form component. We render the placeholder in case
           * you want to provide an actual string where this Select is consumed
           * outside our usual Form component.
           *
           * Note: both optional and required selects have a blank initial value.
           *
           * We check that the default value exists as an option, so that we don't
           * send an invalid value to the server if the user doesn't touch the field.
           */}
          {placeholder &&
          !options.map((o) => o.value).find((v) => v === defaultValue) ? (
            <option value="" disabled={required} selected>
              {placeholder}
            </option>
          ) : null}
          {options.map(({ label, value, disabled }, i) => (
            <option
              value={value}
              disabled={disabled}
              key={i}
              selected={value === defaultValue}
            >
              {label}
            </option>
          ))}
        </StyledSelect>
        <SVG src={Chevron} />
      </SelectWrapper>
    );
  }
);

Select.displayName = 'Select';

Select.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    })
  ),
  required: PropTypes.bool,
  defaultValue: PropTypes.string,
  /** Either a piece of text, or true if the line is to be blank */
  placeholder: PropTypes.oneOf([PropTypes.string, PropTypes.bool]),
  error: PropTypes.bool,
};

export default Select;
